import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4b564e51"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pdf-dropdown-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "pdf-dropdown",
  right: ""
};
const _hoisted_3 = {
  class: "pdf-dropdown-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1));
const _hoisted_6 = {
  class: "buttons"
};
const _hoisted_7 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_button = _resolveComponent("b-button");
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_pdf_export_selector = _resolveComponent("pdf-export-selector");
  const _component_b_spinner = _resolveComponent("b-spinner");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_button, {
    class: "pdf-export-btn",
    variamt: "outline-secondary",
    onClick: $options.handlePdfPopupClick
  }, {
    default: _withCtx(() => [_createTextVNode(" Export as PDF ")]),
    _: 1
  }, 8, ["onClick"]), $data.showPdfDropdown ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_font_awesome_icon, {
    icon: "fa-solid fa-download"
  }), _createTextVNode(" Download PDF Report ")]), _hoisted_4, _createVNode(_component_pdf_export_selector, {
    pages: $props.pdfPages,
    periods: $props.periods,
    onPageSelect: _cache[0] || (_cache[0] = page => $options.handlePageSelect(page)),
    onPeriodSelect: _cache[1] || (_cache[1] = period => $options.handlePeriodSelect(period)),
    selectedPages: $options.getSelectedPages,
    selectedPeriod: $options.getSelectedPeriod,
    onClearAll: $options.handleClearAll,
    onSelectAll: $options.handleSelectAll
  }, null, 8, ["pages", "periods", "selectedPages", "selectedPeriod", "onClearAll", "onSelectAll"]), _createElementVNode("div", null, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_b_button, {
    variant: "secondary",
    onClick: $options.handleDownloadCancel
  }, {
    default: _withCtx(() => [_createTextVNode("Cancel")]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_b_button, {
    variant: "primary",
    onClick: $options.handleDownloadClicked,
    disabled: $options.disableDownload,
    class: "download-btn spinner-btn"
  }, {
    default: _withCtx(() => [$data.downloading ? (_openBlock(), _createBlock(_component_b_spinner, {
      key: 0,
      small: "",
      class: "custom-spinner",
      variant: "light"
    })) : (_openBlock(), _createElementBlock("span", _hoisted_7, " Download "))]),
    _: 1
  }, 8, ["onClick", "disabled"])])])])) : _createCommentVNode("", true)]);
}